<div class="main-container">
    <div class="section page-notFound">
        <h1 class="title">PÁGINA DE ERROR</h1>
        <p>La página que busca no se encuentra disponible. Rogamos disculpe las molestias.</p>
        <div>
            <p>Utilice la herramienta de búsqueda situada en la parte superior derecha de la página para encontrar el contenido que busca.</p>
        </div>
    </div>
</div>